const STEPS = ["Collection", "Your porch", "Your window", "Your details"];

export const StepIndicator = ({ current, dark = false }) => {
  const on = dark ? "var(--pp-parchment)" : "var(--pp-burgundy)";
  const off = dark ? "rgba(233,216,190,0.4)" : "var(--pp-text-muted)";
  const line = dark ? "rgba(233,216,190,0.2)" : "var(--pp-border)";
  return (
    <div className="pp-container pt-8 pb-4">
      <ol className="flex items-center gap-3 sm:gap-5">
        {STEPS.map((label, i) => {
          const n = i + 1;
          const active = n === current;
          const done = n < current;
          return (
            <li key={label} data-testid={`wizard-step-indicator-${n}`} className="flex items-center gap-3 sm:gap-5 min-w-0">
              <span
                className="text-xs tracking-[0.2em] uppercase whitespace-nowrap"
                style={{ color: active || done ? on : off, fontWeight: active ? 600 : 400 }}
              >
                <span className="font-serif-display text-base mr-1.5">{String(n).padStart(2, "0")}</span>
                <span className="hidden sm:inline">{label}</span>
              </span>
              {i < STEPS.length - 1 && (
                <span className="h-px w-6 sm:w-12" style={{ backgroundColor: done ? on : line }} />
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
};
